import React, { useEffect, useState } from 'react';
import { teacherApi, adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaSmile, FaFrown, FaMeh } from 'react-icons/fa';
import toast from 'react-hot-toast';

const TYPE_CFG = { positive:{color:'#10b981',bg:'#d1fae5',icon:FaSmile}, negative:{color:'#ef4444',bg:'#fee2e2',icon:FaFrown}, neutral:{color:'#6b7280',bg:'#f3f4f6',icon:FaMeh} };

export default function Behaviour() {
  const [records,  setRecords]  = useState([]);
  const [learners, setLearners] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [modal,    setModal]    = useState(false);
  const [filter,   setFilter]   = useState('');
  const [form,     setForm]     = useState({ learner_id:'', type:'positive', category:'', description:'', action_taken:'', incident_date:new Date().toISOString().slice(0,10) });

  const load = () => teacherApi.getBehaviour(null).then(r=>setRecords(r.data.data)).finally(()=>setLoading(false));
  useEffect(()=>{ adminApi.getLearners({}).then(r=>setLearners(r.data.data)); load(); },[]);//eslint-disable-line

  const handleSave = async (e) => {
    e.preventDefault();
    try { await teacherApi.addBehaviour(form); toast.success('Record added'); setModal(false); load(); }
    catch (err) { toast.error(err.response?.data?.message||'Failed'); }
  };

  const filtered = filter ? records.filter(r=>r.type===filter) : records;

  return (
    <div>
      <div className="page-header" style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
        <div><h2>Behaviour Records</h2><p>Track learner conduct and achievements</p></div>
        <button className="sms-btn sms-btn-primary" onClick={()=>{setForm({learner_id:'',type:'positive',category:'',description:'',action_taken:'',incident_date:new Date().toISOString().slice(0,10)});setModal(true);}}><FaPlus size={13}/> Add Record</button>
      </div>

      <div style={{display:'flex',gap:8,marginBottom:16}}>
        {[['','All'],['positive','Positive'],['negative','Negative'],['neutral','Neutral']].map(([v,l])=>(
          <button key={v} onClick={()=>setFilter(v)} className="sms-btn" style={{background:filter===v?'#1a1a2e':'#fff',color:filter===v?'#fff':'#6b7280',border:'1px solid #e5e7eb',padding:'7px 16px'}}>{l}</button>
        ))}
      </div>

      {loading ? <Spinner /> : (
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {filtered.map((r,i)=>{
            const cfg = TYPE_CFG[r.type]||TYPE_CFG.neutral;
            return (
              <div key={i} className="sms-card" style={{display:'flex',gap:14,padding:'14px 18px',borderLeft:`4px solid ${cfg.color}`}}>
                <div style={{width:40,height:40,borderRadius:10,background:cfg.bg,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  <cfg.icon color={cfg.color} size={18}/>
                </div>
                <div style={{flex:1}}>
                  <div style={{display:'flex',gap:10,alignItems:'center',marginBottom:4}}>
                    <span style={{fontWeight:600}}>{r.learner_name||'Learner'}</span>
                    <span style={{fontSize:'0.75rem',background:cfg.bg,color:cfg.color,padding:'2px 8px',borderRadius:10,textTransform:'capitalize'}}>{r.type}</span>
                    {r.category&&<span style={{fontSize:'0.75rem',color:'#6b7280'}}>{r.category}</span>}
                  </div>
                  <p style={{color:'#374151',fontSize:'0.88rem',margin:'0 0 4px'}}>{r.description}</p>
                  {r.action_taken&&<p style={{color:'#6b7280',fontSize:'0.82rem',margin:'0 0 4px'}}><strong>Action:</strong> {r.action_taken}</p>}
                  <div style={{color:'#9ca3af',fontSize:'0.75rem'}}>{r.incident_date} · By {r.recorded_by}</div>
                </div>
              </div>
            );
          })}
          {filtered.length===0&&<div className="sms-card" style={{textAlign:'center',color:'#9ca3af',padding:'60px 0'}}>No behaviour records found</div>}
        </div>
      )}

      <Modal show={modal} onClose={()=>setModal(false)} title="Add Behaviour Record">
        <form onSubmit={handleSave}>
          <div style={{marginBottom:14}}><label className="sms-label">Learner*</label>
            <select className="sms-input" value={form.learner_id} onChange={e=>setForm({...form,learner_id:e.target.value})} required>
              <option value="">Select Learner</option>
              {learners.map(l=><option key={l.user_id} value={l.user_id}>{l.first_name} {l.surname} (Gr {l.grade_number})</option>)}
            </select>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
            <div><label className="sms-label">Type*</label>
              <select className="sms-input" value={form.type} onChange={e=>setForm({...form,type:e.target.value})}>
                <option value="positive">Positive</option><option value="negative">Negative</option><option value="neutral">Neutral</option>
              </select>
            </div>
            <div><label className="sms-label">Category</label><input className="sms-input" value={form.category} onChange={e=>setForm({...form,category:e.target.value})} placeholder="e.g. Punctuality"/></div>
          </div>
          <div style={{marginBottom:14}}><label className="sms-label">Description*</label><textarea className="sms-input" rows={3} value={form.description} onChange={e=>setForm({...form,description:e.target.value})} required/></div>
          <div style={{marginBottom:14}}><label className="sms-label">Action Taken</label><input className="sms-input" value={form.action_taken} onChange={e=>setForm({...form,action_taken:e.target.value})}/></div>
          <div style={{marginBottom:20}}><label className="sms-label">Date</label><input className="sms-input" type="date" value={form.incident_date} onChange={e=>setForm({...form,incident_date:e.target.value})}/></div>
          <div style={{display:'flex',gap:10}}>
            <button type="submit" className="sms-btn sms-btn-primary">Save</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={()=>setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
